import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {URL_GEOLOCALIZATION} from '../../../config';
import axios from "axios";
import Modal from "../../../components/modal";
import LoadingSpinner from "../../../components/loading-spinner";
// import {IconButton} from "@material-ui/core";
// import Grid from "@material-ui/core/Grid";
// import Box from "@material-ui/core/Box";
// import PhotoCameraRoundedIcon from "@material-ui/icons/PhotoCameraRounded";
//import Webcam from "react-webcam";
import {
    createAssistControl,
    updateAssistControl,
    clear_assist_control,
    CREATE_ASSIST_CONTROL,
    UPDATE_ASSIST_CONTROL,
    searchAssistControl
} from '../../../redux/assist_control';
import './fileMobile.css';
import {toast} from 'react-toastify';
import Footer from "../../../components/footer";

const data_month = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
];

const data_day = [
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo',
];

function inittDate() {
    try {
        let date = new Date();
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        var value = year + '-' + month + '-' + day;
        return value;
    } catch (e) {
        return null;
    }
}

const Marking = (props) => {
    const dispatch = useDispatch();

    const {token, user} = useSelector((state) => state.users_module.login.data) || null;

    // const [typeModalCamera, setTypeModalCamera] = useState(0);
    const [type, setType] = useState('jornada');
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const [latitudeInitial, setLatitudeInitial] = useState('');
    const [latitudeFinal, setLatitudeFinal] = useState('');
    const [longitudeInitial, setLongitudeInitial] = useState('');
    const [longitudeFinal, setLongitudeFinal] = useState('');
    const [idAssistControl, setIdAssistControl] = useState(0);
    const [adressInitial, setAdreesInitial] = useState('');
    const [adressFinal, setAdreesFinal] = useState('');
    const [timeInitial, setTimeInitial] = useState('08:00:00');
    const [timeFinal, setTimeFinal] = useState('18:00:00');
    // const [namePhotoInitial, setNamePhotoInitial] = useState('');
    // const [uriPhotoInitial, setUriPhotoInitial] = useState('');
    // const [namePhotoFinal, setNamePhotoFinal] = useState('');
    // const [uriPhotoFinal, setUriPhotoFinal] = useState('');
    const [modalMessage, setModalMessage] = useState(false);
    const [modalLaborableDay, setModalLaborableDay] = useState(false);
    // const [modalCamera, setModalCamera] = useState(false);
    const [buttonFinal, setButtonFinal] = useState(true);
    // eslint-disable-next-line
    const [date, setDate] = useState(inittDate());
    // const [file, setFile] = useState(null);
    // const [fileImage, setFileImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [nonworking, setNonworking] = useState(false);

    useEffect(() => {
        var days = new Date().getDate();
        var weeks = new Date().getDay() - 1;
        var months = new Date().getMonth();
        var years = new Date().getFullYear();
        setDay(data_day[weeks]);
        setMonth(days + ' ' + data_month[months]);
        setYear(years);
        assist_control();
        // eslint-disable-next-line
    }, []);

    async function assist_control() {
        // eslint-disable-next-line
        let params = "?usuario=" + user + '&&marcacion=1' + '&&codigo_tipo=' + type;

        const response = await searchAssistControl(token, params);
        console.log(response)
        if (response.data.datos.length > 0) {
            let data = response.data.datos[0];
            setIdAssistControl(data.id);
            console.log('data');
            console.log(data);
            if (data && data.codigo_tipo === 'no_laborable') {
                let fecha = inittDate();
                console.log(fecha);
                if (fecha === data.ubicacion_inicial.fecha) {
                    setNonworking(true);
                }
            }
            if (data && data.ubicacion_inicial) {
                setTimeInitial(data.ubicacion_inicial.hora);
                let latitude = data.ubicacion_inicial.latitud;
                let longitude = data.ubicacion_inicial.longitud;
                setLatitudeInitial(latitude);
                setLongitudeInitial(longitude);
                geodecoder(1, latitude, longitude);
                let v_date = new Date(data.ubicacion_inicial.fecha + " 00:00:00");
                var days = v_date.getDate();
                var weeks = v_date.getDay() - 1;
                var months = v_date.getMonth();
                var years = v_date.getFullYear();
                setDay(data_day[weeks]);
                setMonth(days + ' ' + data_month[months]);
                setYear(years);
                // let nameImageInitial = URLAPI + data.ubicacion_inicial.imagenes[0].nombre;
                // let imageInitial = URLAPI + data.ubicacion_inicial.imagenes[0].imagen;
                // setNamePhotoInitial(nameImageInitial);
                // setUriPhotoInitial(imageInitial);
            }
            if (data && data.ubicacion_final) {
                setTimeFinal(data.ubicacion_final.hora);
                let latitudef = data.ubicacion_final.latitud;
                let longitudef = data.ubicacion_final.longitud;
                setLatitudeFinal(latitudef);
                setLongitudeFinal(longitudef);
                geodecoder(2, latitudef, longitudef);
                // let nameImageFinal = URLAPI + data.ubicacion_final.imagenes[0].nombre;
                // let imageFinal = URLAPI + data.ubicacion_final.imagenes[0].imagen;
                // setNamePhotoFinal(nameImageFinal);
                // setUriPhotoFinal(imageFinal);
                setButtonFinal(false);
            }
            /* } */
        }
    }

    function getGeolocation(id) {
        // setIsLoading(true);
        navigator.geolocation.getCurrentPosition(
            function (position) {
                /* dispatch(createLocationTaskScheduled(token,
                    {
                        latitud: position.coords.latitude,
                        longitud: position.coords.longitude,
                        usuario: user,
                        id_tarea_horario: item.id
                    }
                )); */
                if (id === 1) {
                    setLatitudeInitial(position.coords.latitude);
                    setLongitudeInitial(position.coords.longitude);
                }
                if (id === 2) {
                    setLatitudeFinal(position.coords.latitude);
                    setLongitudeFinal(position.coords.longitude);
                }
                geodecoder(id, position.coords.latitude, position.coords.longitude)
            },
            (err) => {
                console.log(err)
            },
            {enableHighAccuracy: false, timeout: 27000, maximumAge: 30000});
    }

    function geodecoder(id, latitude, longitude) {
        var config = {
            method: 'get',
            url:
                URL_GEOLOCALIZATION +
                '?format=jsonv2&lat=' +
                latitude +
                '&lon=' +
                longitude,
            headers: {},
        };
        axios(config)
            .then(function (response) {
                if (id === 1) {
                    setAdreesInitial(response.data.display_name);
                }
                if (id === 2) {
                    setAdreesFinal(response.data.display_name);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    // const comprimirImagen = (imagenComoArchivo, porcentajeCalidad) => {
    //     return new Promise((resolve, reject) => {
    //         const $canvas = document.createElement("canvas");
    //         const imagen = new Image();
    //         imagen.onload = () => {
    //             $canvas.width = imagen.width;
    //             $canvas.height = imagen.height;
    //             $canvas.getContext("2d").drawImage(imagen, 0, 0);
    //             $canvas.toBlob(
    //                 (blob) => {
    //                     if (blob === null) {
    //                         return reject(blob);
    //                     } else {
    //                         resolve(blob);
    //                     }
    //                 },
    //                 "image/jpeg",
    //                 porcentajeCalidad / 100,
    //             );
    //         };
    //         imagen.src = URL.createObjectURL(imagenComoArchivo);
    //     });
    // };

    // const handleSubmit = async () => {
    //     console.log(typeModalCamera);
    //     if (typeModalCamera === 1) {
    //         setNamePhotoInitial(file.name);
    //         setUriPhotoInitial(fileImage);
    //     }
    //     if (typeModalCamera === 2) {
    //         setNamePhotoFinal(file.name);
    //         setUriPhotoFinal(fileImage);
    //     }
    //     // setModalCamera(false);
    //     //handleClear();
    //     /* const blob = await comprimirImagen(file, 40);
    //     setIsLoading(true);
    //     let form = new FormData();
    //     var fileConvert = new File([blob], file.name);
    //     form.append("foto", fileConvert); */
    // }

    // const handleCapture = (target) => {
    //     if (target.files) {
    //         if (target.files.length !== 0) {
    //             const file = target.files[0];
    //             setFile(file);
    //             const newUrl = URL.createObjectURL(file);
    //             setFileImage(newUrl);
    //         }
    //     }
    // };

    /* const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            setImgSrc(imageSrc);
        },
        [webcamRef]
    ); */

    // function handleClear() {
    //     setFileImage(null);
    //     setFile(null);
    // }

    // const web = navigator.userAgent.toUpperCase();
    // let mobile = web.indexOf("MOBILE");
    // let android = web.indexOf("ANDROID");
    // let iphone = web.indexOf("IPHONE");

    const _create_assist_control = useSelector(
        (state) => state.assist_control_module._create_assist_control
    );

    const _update_assist_control = useSelector(
        (state) => state.assist_control_module._update_assist_control
    );

    useEffect(() => {
        if (_create_assist_control) {
            if (_create_assist_control.status === 201) {
                setModalLaborableDay(false);
                setModalMessage(true);
                dispatch(clear_assist_control(CREATE_ASSIST_CONTROL));
                assist_control();
            } else if (_create_assist_control.status !== 0) {
                dispatch(clear_assist_control(CREATE_ASSIST_CONTROL));
                toast.error(_create_assist_control.message, {position: toast.POSITION.TOP_RIGHT});
                setModalLaborableDay(false);
            }
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_create_assist_control, dispatch]);

    useEffect(() => {
        if (_update_assist_control) {
            if (_update_assist_control.status === 200) {
                setModalMessage(true);
                dispatch(clear_assist_control(UPDATE_ASSIST_CONTROL));
                assist_control();
                setButtonFinal(false);
            } else if (_update_assist_control.status !== 0) {
                dispatch(clear_assist_control(UPDATE_ASSIST_CONTROL));
                toast.error(_update_assist_control.message, {position: toast.POSITION.TOP_RIGHT});
            }
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_update_assist_control, dispatch]);

    async function create_marking() {
        setIsLoading(true);
        // const blob = await comprimirImagen(file, 40);
        // var fileConvert = new File([blob], file.name);
        let data = {};
        data['usuario'] = user;
        data['codigo_tipo'] = type;
        if (type !== 'no_laborable') {
            data['latitud'] = latitudeInitial;
            data['longitud'] = longitudeInitial;
            // data['imagen'] = fileConvert;
        }
        dispatch(createAssistControl(token, data));
    }

    async function update_marking() {
        setIsLoading(true);
        // const blob = await comprimirImagen(file, 40);
        // var fileConvert = new File([blob], file.name);
        let data = {};
        data['usuario'] = user;
        data['codigo_tipo'] = type;
        if (type !== 'no_laborable') {
            data['latitud'] = latitudeFinal;
            data['longitud'] = longitudeFinal;
            // data['imagen'] = fileConvert;
        }
        dispatch(updateAssistControl(token, idAssistControl, data));
    }

    return (
        <>
            <div className="app-content content">
                {isLoading && <LoadingSpinner/>}
                <div className="content-wrapper">
                    {/* <div className="content-header row">
                        <div className="content-header-left col-12 mb-2 ">
                            <Breadcrumbs
                                title="Tareas"
                                items={[{label: "Lista", link: "/tareas"}]}
                            />
                        </div>
                    </div> */}
                    <div className="content-body">
                        <div className="card">
                            <div className="card-content">
                                <div className="card-body">
                                    <div className='text-center'>
                                        <p className='texto_30'>{day}</p>
                                        <p className='texto_24'>{month}</p>
                                        <p className='texto_16'>{year}</p>
                                    </div>
                                    <div className='row mt-2'>
                                        <div className='col-6'>
                                            <div className='mb-1'>
                                                {/*eslint-disable-next-line */}
                                                <img className='ml-2 img_1'
                                                     src={window.location.origin + "/base/app-assets/images/icon/entrada.png"}
                                                />
                                                <span className="ml-1 texto_24">Entrada</span>
                                            </div>
                                        </div>
                                        <div className='col-6 text-center'>
                                            {idAssistControl === 0 && (
                                                (adressInitial) ?
                                                    <>
                                                        {/*eslint-disable-next-line*/}
                                                        <a href="#" onClick={() => {
                                                            create_marking();
                                                        }} className="btn text-bold-700 btn_2">
                                                            Confirmar
                                                        </a>
                                                    </>
                                                    :
                                                    <>
                                                        {/*eslint-disable-next-line*/}
                                                        <a href="#" onClick={() => {
                                                            setType('jornada');
                                                            getGeolocation(1);
                                                            // setTypeModalCamera(1);
                                                            // handleClear();
                                                            // setModalCamera(true);
                                                        }} className="btn text-bold-700 btn_1">
                                                            Marcar
                                                        </a>
                                                    </>
                                            )}
                                        </div>
                                        <div className='col-12 text-center mb-1'>
                                            <span className='border_clock texto_48'>{timeInitial}</span>
                                        </div>
                                        <div className='col-12'>
                                            {/*{namePhotoInitial ? (*/}
                                            {/*    <img className='ml-2 img_2'*/}
                                            {/*        src={uriPhotoInitial}*/}
                                            {/*        alt="img"*/}
                                            {/*    />*/}
                                            {/*) : (*/}
                                            {/*    <img className='ml-2 img_2'*/}
                                            {/*        src={window.location.origin + "/base/app-assets/images/icon/image.png"}*/}
                                            {/*        alt="img"*/}
                                            {/*    />*/}
                                            {/*)}*/}
                                            <img className='ml-2'
                                                 src={window.location.origin + "/base/app-assets/images/icon/position.png"}
                                                 alt="img"
                                                 height="30"
                                                 width="30"/>
                                            <span className="ml-1 texto_16">{adressInitial}</span>
                                        </div>
                                    </div>
                                    <div className='row mt-2'>
                                        <div className='col-6'>
                                            <div className='mb-1'>
                                                <img className='ml-2 img_1'
                                                     src={window.location.origin + "/base/app-assets/images/icon/salida.png"}
                                                     alt="img"
                                                />
                                                <span className="ml-1 texto_24">Salida</span>
                                            </div>
                                        </div>
                                        <div className='col-6 text-center'>
                                            {idAssistControl !== 0 && (
                                                (adressFinal) ? (
                                                    buttonFinal &&
                                                    <>
                                                        {/*eslint-disable-next-line*/}
                                                        <a href="#" onClick={() => {
                                                            update_marking();
                                                        }} className="btn text-bold-700 btn_2">
                                                            Confirmar
                                                        </a>
                                                    </>
                                                ) : (
                                                    (!nonworking) &&
                                                    <>
                                                        {/*eslint-disable-next-line*/}
                                                        <a href="#" onClick={() => {
                                                            setType('jornada');
                                                            getGeolocation(2);
                                                            // setTypeModalCamera(2);
                                                            // handleClear();
                                                            // setModalCamera(true);
                                                        }} className="btn text-bold-700 btn_1">
                                                            Marcar
                                                        </a>
                                                    </>
                                                )
                                            )}
                                        </div>
                                        <div className='col-12 text-center mb-1'>
                                            <span className='border_clock texto_48'>{timeFinal}</span>
                                        </div>
                                        <div className='col-12'>
                                            {/*{namePhotoFinal ? (*/}
                                            {/*    <img className='ml-2 img_2'*/}
                                            {/*        src={uriPhotoFinal}*/}
                                            {/*        alt="img"*/}
                                            {/*    />*/}
                                            {/*) : (*/}
                                            {/*    <img className='ml-2 img_2'*/}
                                            {/*        src={window.location.origin + "/base/app-assets/images/icon/image.png"}*/}
                                            {/*        alt="img"*/}
                                            {/*    />*/}
                                            {/*)}*/}
                                            <img className='ml-2'
                                                 src={window.location.origin + "/base/app-assets/images/icon/position.png"}
                                                 alt="img"
                                                 height="30"
                                                 width="30"/>
                                            <span className="ml-1 texto_16">{adressFinal}</span>
                                        </div>
                                    </div>
                                    {(idAssistControl === 0) &&
                                        <div className='mt-3 text-center'>
                                            {/*eslint-disable-next-line*/}
                                            <a href="#" onClick={() => {
                                                setModalLaborableDay(true);
                                                setType('no_laborable');
                                            }} className="btn text-bold-700 btn_3">
                                                Marcar como no laborable
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal className="modal-main" show={modalMessage} style={{width: "70%"}}>
                    <div className="m-1 text-center">
                        <img
                            src={window.location.origin + "/base/app-assets/images/icon/success.png"}
                            alt="img"
                            className='img_3'
                        />
                        <br/><br/>
                        <p className='texto_24 text-bold-400'>Se ha registrado la marcación de forma exitosa</p>
                        <br/><br/>
                        {/*eslint-disable-next-line*/}
                        <a href="#" onClick={() => {
                            setModalMessage(false);
                        }} className="btn text-bold-700 btn_1">
                            Ok
                        </a>
                    </div>
                </Modal>
                <Modal className="modal-main" show={modalLaborableDay} style={{width: "70%"}}>
                    <div className="m-1 text-center">
                        <img
                            src={window.location.origin + "/base/app-assets/images/icon/help.png"}
                            alt="img"
                            height="96"
                            width="96"
                        />
                        <br/><br/>
                        <p className='texto_24'>¿Desea marcar este día como no laborable?</p>
                        <br/><br/>
                        {/*eslint-disable-next-line*/}
                        <a href="#" onClick={() => {
                            create_marking();
                        }} className="btn text-bold-700 mb-1 btn_1">
                            Confirmar
                        </a>
                        {/*eslint-disable-next-line*/}
                        <a href="#" onClick={() => {
                            setModalLaborableDay(false);
                        }} className="btn text-bold-700 btn_1">
                            Cancelar
                        </a>
                    </div>
                </Modal>
                {/*<Modal className="modal-main" show={modalCamera} style={{width: "80%"}}>*/}
                {/*    {isLoading && <LoadingSpinner/>}*/}
                {/*    <div className="modal-header">*/}
                {/*        <p style={{color: 'transparent'}}>.</p>*/}
                {/*        <button type="button" style={{marginRight: -24}}*/}
                {/*                className="btn btn-calendar badge-circle" onClick={() => {*/}
                {/*            handleClear();*/}
                {/*            setModalCamera(false);*/}
                {/*            if (typeModalCamera === 1) {*/}
                {/*                setUriPhotoInitial('');*/}
                {/*                setNamePhotoInitial('');*/}
                {/*            }*/}
                {/*            if (typeModalCamera === 2) {*/}
                {/*                setUriPhotoFinal('');*/}
                {/*                setNamePhotoFinal('');*/}
                {/*            }*/}
                {/*        }}> X*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*    {(mobile === -1 && android === -1 && iphone === -1) ? (*/}
                {/*        <div className="container text-center">*/}
                {/*            <h5 className='text-bold-400 texto_24'>Use un teléfono para continuar</h5>*/}
                {/*            /!* {imgSrc ? (*/}
                {/*                <div className='mt-2 mb-2'>*/}
                {/*                    <img src={imgSrc} alt="webcam" />*/}
                {/*                    <a href="#" onClick={() => {convert_photo()}} className="btn text-bold-700 mt-1"*/}
                {/*                    style={{background: '#FFC912', borderRadius: 10, padding: 10, color: '#000000', width: '70%'}}>*/}
                {/*                        Continuar*/}
                {/*                    </a>*/}
                {/*                    <a href="#" onClick={() => {setImgSrc(null);}} className="btn text-bold-700 mt-1"*/}
                {/*                    style={{background: '#FFC912', borderRadius: 10, padding: 10, color: '#000000', width: '70%'}}>*/}
                {/*                        Regresar */}
                {/*                    </a>*/}
                {/*                </div>*/}
                {/*            ) : (*/}
                {/*                modalCamera &&*/}
                {/*                    <div className='mt-2 mb-2'>*/}
                {/*                        <Webcam */}
                {/*                            ref={webcamRef} */}
                {/*                            width="80%"*/}
                {/*                            height="auto"*/}
                {/*                            screenshotFormat="image/jpeg"*/}
                {/*                            screenshotQuality={0.8}*/}
                {/*                        />*/}
                {/*                        <a href="#" onClick={capture} className="btn text-bold-700 mt-1"*/}
                {/*                        style={{background: '#FFC912', borderRadius: 10, padding: 10, color: '#000000', width: '70%', }}>*/}
                {/*                            Tomar foto*/}
                {/*                        </a>*/}
                {/*                    </div>*/}
                {/*            )} *!/*/}
                {/*        </div> */}
                {/*    ) : (*/}
                {/*        <div className="root">*/}
                {/*            <Grid container>*/}
                {/*                <Grid item xs={12}>*/}
                {/*                    <div className={!file && 'btnPhoto'}>*/}
                {/*                        <h5 className='text-bold-400 texto_24 mt-1'>Presione el botón para tomar la fotografía</h5>*/}
                {/*                        {file && (*/}
                {/*                            <>*/}
                {/*                                <Box*/}
                {/*                                    display="flex"*/}
                {/*                                    justifyContent="center"*/}
                {/*                                    border={1}*/}
                {/*                                    className="imgBox"*/}
                {/*                                >*/}
                {/*                                    <img src={fileImage} alt={"snap"} className="img" width="80%" height="80%"/>*/}
                {/*                                </Box>*/}
                {/*                            </>*/}
                {/*                        )}*/}
                {/*                        <input*/}
                {/*                            accept="image/*"*/}
                {/*                            className="input"*/}
                {/*                            id="icon-button-file"*/}
                {/*                            type="file"*/}
                {/*                            capture="environment"*/}
                {/*                            onChange={(e) => handleCapture(e.target)}*/}
                {/*                        />*/}
                {/*                        <label htmlFor="icon-button-file">*/}
                {/*                            <IconButton*/}
                {/*                                color="primary"*/}
                {/*                                aria-label="Tomar fotografía"*/}
                {/*                                component="span"*/}
                {/*                            >*/}
                {/*                                <PhotoCameraRoundedIcon fontSize="large" color="primary"/>*/}
                {/*                            </IconButton>*/}
                {/*                        </label>*/}
                {/*                        {*/}
                {/*                            fileImage && (*/}
                {/*                                <div className="text-center mb-1">*/}
                {/*                                    /!*eslint-disable-next-line *!/*/}
                {/*                                    <a href="#" onClick={handleSubmit} className="btn text-bold-700 mt-1 btn_1">*/}
                {/*                                        Continuar*/}
                {/*                                    </a>*/}
                {/*                                </div>*/}
                {/*                            )*/}
                {/*                        }*/}
                {/*                    </div>*/}
                {/*                </Grid>*/}
                {/*            </Grid>*/}
                {/*        </div>*/}
                {/*    )}*/}
                {/*</Modal>*/}
            </div>
            <div className="app-content content">
                <Footer/>
            </div>
        </>
    )
}

export default Marking;